/**
 * @file index.tsx
 *
 * @fileoverview Shows organization contacts.
 */
import { OrganizationContactsWidgetView } from '~/jobiqo/components/Organization/Widgets/Contacts/View';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { isSectionHidden } from '~/jobiqo/utils/config';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

const KEY = 'contact';

export interface OrganizationContactsWidgetProps {
  /**
   * The current organization profile.
   */
  organization: OrganizationProfile;
  /**
   * The current box id.
   */
  boxId: string | undefined;
}

export const OrganizationContactsWidget = ({
  organization,
  boxId,
}: OrganizationContactsWidgetProps) => {
  const { ORGANIZATIONS } = useFrontendConfig();
  const GROUP_FIELDS = ORGANIZATIONS.ORGANIZATION_PAGE_FIELDS[KEY];

  if (isSectionHidden(GROUP_FIELDS, organization.hiddenFields)) {
    return null;
  }

  return (
    <OrganizationContactsWidgetView organization={organization} boxId={boxId} />
  );
};
